import { Formik, FormikProps } from "formik";
import React from "react";

interface Props {
  initialValues: any;
  onSubmit: any;
  validationSchema?: any;
  children: React.ReactNode;
  innerRef?: any;
  [otherProps: string]: any;
}

const AppForm: React.FC<Props> = ({
  initialValues,
  onSubmit,
  validationSchema,
  innerRef,
  children,
  ...otherProps
}) => {
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
      enableReinitialize={true}
      validateOnChange={false}
      validateOnBlur={false}
      innerRef={innerRef}
      {...otherProps}
    >
      {(props: FormikProps<any>) => {
        return (
          <form
            onSubmit={props.handleSubmit}
          >
            {children}
          </form>
        );
      }}
    </Formik>
  );
};

export default AppForm;
